import { Route } from '@angular/router';
import { authenticationGuard, featureFlagsResolver } from '@ps-gui/shared-core';
import { gutachtenGuard } from '../guards/gutachten-guard';

export const appRoutes: Route[] = [
  {
    path: '',
    loadChildren: () => import('@ps-gui/dashboard-base-lib').then((m) => m.dashboardRoutes),
    canActivate: [authenticationGuard],
  },
  {
    path: 'proof',
    loadChildren: () => import('@ps-gui/proof-lib').then((m) => m.proofRoutes),
    canActivate: [authenticationGuard],
  },
  {
    path: 'gutachten',
    loadChildren: () => import('@ps-gui/gutachten-lib').then((m) => m.gutachtenRoutes),
    canActivate: [gutachtenGuard, authenticationGuard],
    resolve: { featureFlags: featureFlagsResolver },
  },
  {
    path: 'outbound',
    loadChildren: () => import('@ps-gui/outbound-lib').then((m) => m.outboundRoutes),
    canActivate: [authenticationGuard],
  },
  {
    path: 'gm-aktenlage',
    loadChildren: () => import('@ps-gui/web-order-lib').then((m) => m.gmAktenlageRoutes),
    canActivate: [authenticationGuard],
    data: {
      headerLeftSlotComponent: () =>
        import('@ps-gui/web-order-lib').then((m) => m.GmHeaderBreadcrumbComponent),

      headerBreadcrumbData: {
        title: 'Gutachten, nach Aktenlage',
      },
    },
  },
  {
    path: 'gm-vorstellung',
    loadChildren: () => import('@ps-gui/web-order-lib').then((m) => m.gmVorstellungRoutes),
    canActivate: [authenticationGuard],
    data: {
      headerLeftSlotComponent: () =>
        import('@ps-gui/web-order-lib').then((m) => m.GmHeaderBreadcrumbComponent),

      headerBreadcrumbData: {
        title: 'Gutachten, mit Vorstellung',
      },
    },
  },
  {
    path: 'dokumente-nachreichen',
    loadChildren: () => import('@ps-gui/web-order-lib').then((m) => m.nachreichungRoutes),
    canActivate: [authenticationGuard],
  },
  {
    path: 'attachment-download',
    loadChildren: () =>
      import('@ps-gui/attachment-download-lib').then((m) => m.attachmentDownloadRoutes),
    canActivate: [authenticationGuard],
  },
];
